/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_ItalianInputs */

const en_speechmatics_target_language_italian = /** @type {(inputs: Speechmatics_Target_Language_ItalianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italian`)
};

const fr_speechmatics_target_language_italian = /** @type {(inputs: Speechmatics_Target_Language_ItalianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italien`)
};

const de_speechmatics_target_language_italian = /** @type {(inputs: Speechmatics_Target_Language_ItalianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italienisch`)
};

const it_speechmatics_target_language_italian = /** @type {(inputs: Speechmatics_Target_Language_ItalianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const ru_speechmatics_target_language_italian = /** @type {(inputs: Speechmatics_Target_Language_ItalianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`итальянский`)
};

const es_speechmatics_target_language_italian = /** @type {(inputs: Speechmatics_Target_Language_ItalianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`italiano`)
};

const zh_cn2_speechmatics_target_language_italian = /** @type {(inputs: Speechmatics_Target_Language_ItalianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`意大利语`)
};

const ja_speechmatics_target_language_italian = /** @type {(inputs: Speechmatics_Target_Language_ItalianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イタリア語`)
};

const hi_speechmatics_target_language_italian = /** @type {(inputs: Speechmatics_Target_Language_ItalianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इतालवी`)
};

const pt_pt2_speechmatics_target_language_italian = /** @type {(inputs: Speechmatics_Target_Language_ItalianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`italiano`)
};

/**
* | output |
* | --- |
* | "Italian" |
*
* @param {Speechmatics_Target_Language_ItalianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_italian = /** @type {((inputs?: Speechmatics_Target_Language_ItalianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_ItalianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_italian(inputs)
	if (locale === "de") return de_speechmatics_target_language_italian(inputs)
	if (locale === "it") return it_speechmatics_target_language_italian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_italian(inputs)
	if (locale === "es") return es_speechmatics_target_language_italian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_italian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_italian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_italian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_italian(inputs)
	return en_speechmatics_target_language_italian(inputs)
});